module.exports = __webpack_public_path__ + "img/wz-5-11.736c9432.png";